import { Box, HStack, Text } from "@chakra-ui/react";
import { ProfileDropdown } from "./ProfileDropdown";

interface UserSmudgeProps {
  name: string;
  email: string;
  image?: string;
}

export const UserSmudge = (props: UserSmudgeProps) => {
  const { name, email } = props;

  return (
    <HStack spacing="3" ps="2">
      <ProfileDropdown />

      <Box>
        <Text fontWeight="medium" fontSize="sm">
          {name}
        </Text>
        <Text fontSize="xs" noOfLines={1}>
          {email}
        </Text>
      </Box>
    </HStack>
  );
};
